
<template>
  <div>
    <div v-if="model.driver">
      Última placa usada pelo motorista: <span class="red--text font-weight-bold">{{ model.driver?.last_truck?.plate || "---"  }}</span>
    </div>
    <v-autocomplete
      v-model="model.truck"
      :items="all_trucks"
      return-object
      item-text="plate"
      label="Caminhão"
      :loading="loading_trucks"
      :readonly='loading_trucks'
      prepend-icon="mdi-truck"
      :rules="object_required"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import Api from '@/api/index.js'
import validations from '@/mixins/validations.js'

export default {
  name: 'SelectTruck',
  mixins: [ validations ],
  props: {
    model: {
      type: Object,
    },
  },
  data() {
    return {
      loading_trucks: true,
      all_trucks: [],
    }
  },
  methods: {
    getFilter(){
      return {modality_ids: [this.model.modality_id]}
    },
    getTrucks() {
      this.all_trucks = []
      this.loading_trucks = true
      let filter = this.getFilter()
      Api.Truck.index(filter).then(r=>r.data).then(d=>{
        d = d.data? d.data.map(ds=>ds.attributes) : d
        this.all_trucks = [...d]
      }).catch(err=>{
        console.error(err);
      }).finally(()=>{
        this.loading_trucks = false
      })
    },
  },
  mounted () {
    this.getTrucks();
  },
}
</script>